__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/42e2560/_next/";